import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import bookingApi from "../api/bookingApi";

// Async thunk for fetching bookings
export const fetchAllBookings = createAsyncThunk("booking/fetchBookings", async (_, thunkAPI) => {
  try {
    const res = await bookingApi.getAll();
    return res?.data.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

export const getBookingById = createAsyncThunk("booking/bookingById", async (id, thunkAPI) => {
  try {
    const res = await bookingApi.getById(id);
    return res?.data.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

export const createBooking = createAsyncThunk("booking/createBooking", async (bookingData, thunkAPI) => {
  try {
    const res = await bookingApi.create(bookingData);
    return res?.data.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

export const deleteBooking = createAsyncThunk("booking/deleteBooking", async (id, thunkAPI) => {
  try {
    const res = await bookingApi.delete(id);
    return res?.data.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

export const updateBooking = createAsyncThunk("booking/updateBooking", async (bookingData, thunkAPI) => {
  try {
    const res = await bookingApi.update(bookingData.id, bookingData);
    return res?.data.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

const bookingSlice = createSlice({
  name: "booking",
  initialState: {
    bookings: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllBookings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllBookings.fulfilled, (state, action) => {
        state.loading = false;
        state.bookings = action.payload;
      })
      .addCase(fetchAllBookings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateBooking.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createBooking.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createBooking.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateBooking.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.bookings.findIndex(booking => booking.id === action.payload.id);
        if (index !== -1) {
          state.bookings[index] = action.payload;
        }
      })
      .addCase(updateBooking.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createBooking.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteBooking.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteBooking.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteBooking.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default bookingSlice.reducer;
